export default __webpack_public_path__ + "static/media/steps-cover-6.5cec3e8c.png";